import NotificationRepository from './../../ports/notificationRepository';
import {
  buildNotification,
  addNotificationUseCase as _addNotificationUseCase
} from './add-notification'

import {
  buildFetchNotifications,
  fetchNotificationsUseCase as _fetchNotificationsUseCase
} from './fetch-notifications'

import {
  buildUpdateNotification,
  updateNotificationUseCase as _updateNotificationUseCase
} from './update-notification'

import {
  buildFetchNotificationsCount,
  fetchNotificationsCountUseCase as _fetchNotificationsCountUseCase
} from './fetch-notifications-count'


// eslint-disable-next-line import/no-anonymous-default-export
export default (dependencies: {
  notificationRepo: NotificationRepository;
}): {
  addNotification: _addNotificationUseCase;
  fetchNotifications: _fetchNotificationsUseCase;
  updateNotification: _updateNotificationUseCase;
  fetchNotificationsCount: _fetchNotificationsCountUseCase;
} => {
  const { notificationRepo } = dependencies;

  const addNotification = buildNotification({ notificationRepo });
  const fetchNotifications = buildFetchNotifications({ notificationRepo });
  const updateNotification = buildUpdateNotification({ notificationRepo });
  const fetchNotificationsCount = buildFetchNotificationsCount({ notificationRepo });

  return { addNotification, fetchNotifications, updateNotification, fetchNotificationsCount };
};

export type addNotificationUseCase = _addNotificationUseCase;
export type fetchNotificationsUseCase = _fetchNotificationsUseCase;
export type updateNotificationUseCase = _updateNotificationUseCase;
export type fetchNotificationsCountUseCase = _fetchNotificationsCountUseCase;